import { cva } from "class-variance-authority";

/** Separado del componente para poder darle forma de botón a un `<Link>`. */
export const buttonVariants = cva(
  "inline-flex shrink-0 cursor-pointer items-center justify-center gap-2 font-medium whitespace-nowrap " +
    "transition-colors disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        primary: "bg-primary text-primary-foreground hover:bg-primary-hover font-semibold",
        secondary:
          "border-border-strong text-foreground hover:bg-surface-muted border bg-transparent",
        ghost:
          "text-muted-foreground hover:bg-surface-muted hover:text-foreground bg-transparent",
        danger: "bg-danger text-primary-foreground hover:bg-danger/90 font-semibold",
        "danger-outline":
          "border-danger/40 text-danger hover:bg-danger/10 border bg-transparent",
        "warning-soft":
          "border-warning/45 bg-warning/8 text-warning hover:bg-warning/14 border",
      },
      size: {
        lg: "h-12 px-6 text-[15px]",
        md: "h-11 px-5 text-sm",
        sm: "h-10 px-4 text-sm",
        xs: "h-9 px-3 text-[13px]",
        "2xs": "h-8 px-2.5 text-xs",
      },
      shape: {
        pill: "rounded-full",
        rounded: "rounded-row",
      },
    },
    defaultVariants: { variant: "primary", size: "md", shape: "pill" },
  },
);
